import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsProgress.module.scss";
import {useSongsProgressLogic} from "./SongsProgress.logic";
import SongsProgressCard from "../../../components/dashboard/SongsProgressCard";

export const SongsProgress: VoidFunctionComponent = () => {
  const {redeemableSongCredits, passedPerformances, starsEarnedTowardsNextSongCredit, totalStarsRequiredByNextSongCredit} = useSongsProgressLogic();
  return (
    <section className={s.container}>
      <dl>
        <SongsProgressCard label={`Free song credits`} cardValue={redeemableSongCredits}/>
        <SongsProgressCard label={`Stars earned toward next free song credit`} cardValue={starsEarnedTowardsNextSongCredit} totalValue={totalStarsRequiredByNextSongCredit}/>
        <SongsProgressCard label={`Songs performed with 80% or greater accuracy`} cardValue={passedPerformances}/>
      </dl>
    </section>
  );
}
